import React from 'react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import type { RecentActivity } from '../../types/dashboard';

interface RecentActivitiesProps {
  activities: RecentActivity[];
}

const RecentActivities: React.FC<RecentActivitiesProps> = ({ activities }) => {
  const getStatusColor = (status?: string) => {
    switch (status) {
      case 'completed':
        return 'bg-green-100 text-green-800';
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'overdue':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200">
      <div className="p-6 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900">
          Atividades Recentes
        </h3>
      </div>
      
      <div className="divide-y divide-gray-200">
        {activities.map((activity) => (
          <div key={activity.id} className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <h4 className="text-sm font-medium text-gray-900">
                  {activity.title}
                </h4>
                {activity.description && (
                  <p className="mt-1 text-sm text-gray-500">
                    {activity.description}
                  </p>
                )}
              </div>
              
              <div className="flex items-center space-x-4">
                {activity.amount && (
                  <span className="text-sm font-medium text-gray-900">
                    {new Intl.NumberFormat('pt-BR', {
                      style: 'currency',
                      currency: 'BRL'
                    }).format(activity.amount)}
                  </span>
                )}
                
                {activity.status && (
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(activity.status)}`}>
                    {activity.status === 'completed' ? 'Concluído' :
                     activity.status === 'pending' ? 'Pendente' : 'Atrasado'}
                  </span>
                )}
                
                <span className="text-sm text-gray-500">
                  {format(activity.date, "d 'de' MMMM", { locale: ptBR })}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentActivities;